<template>
  <el-dialog :title="!dataForm.id ? '新增' : '修改'"
             :close-on-click-modal="false"
             :visible.sync="visible">
    <el-form :model="dataForm"
             :rules="dataRule"
             ref="dataForm"
             @keyup.enter.native="dataFormSubmit()"
             label-width="80px">
      <el-form-item label="openid"
                    prop="openid">
        <el-input disabled
                  v-model="dataForm.openid"
                  placeholder="openid"></el-input>
      </el-form-item>
      <el-form-item label="电话"
                    prop="phone">
        <el-input disabled
                  v-model="dataForm.phone"
                  placeholder="电话"></el-input>
      </el-form-item>
      <el-form-item label="用户类型"
                    prop="type">
        <el-radio v-model="dataForm.type"
                  label=0>普通类型</el-radio>
        <el-radio v-model="dataForm.type"
                  label=1>Vip</el-radio>
        <el-radio v-model="dataForm.type"
                  label=2>黑名单</el-radio>
      </el-form-item>
      <el-form-item label="到期时间"
                    prop="vipdqtime">
        <el-input v-model="dataForm.vipdqtime"
                  placeholder="到期时间"></el-input>
      </el-form-item>
      <el-form-item label="认证状态"
                    prop="rzstatus">
        <el-radio v-model="dataForm.rzstatus"
                  label=0>未认证</el-radio>
        <el-radio v-model="dataForm.rzstatus"
                  label=1>已经认证</el-radio>
      </el-form-item>
      <el-form-item label="名字"
                    prop="name">
        <el-input disabled
                  v-model="dataForm.name"
                  placeholder="名字"></el-input>
      </el-form-item>
      <el-form-item label="公司名字"
                    prop="gsname">
        <el-input disabled
                  v-model="dataForm.gsname"
                  placeholder="公司名字"></el-input>
      </el-form-item>
      <el-form-item label="报价次数"
                    prop="bjcishu">
        <el-input disabled
                  v-model="dataForm.bjcishu"
                  placeholder="报价次数"></el-input>
      </el-form-item>
      <el-form-item label="创建时间"
                    prop="createtime">
        <el-input disabled
                  v-model="dataForm.createtime"
                  placeholder="创建时间"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary"
                 @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: 0,
        openid: '',
        phone: '',
        type: '',
        rzstatus: '',
        name: '',
        gsname: '',
        gszhizhao: '',
        vipdqtime: '',
        headurl: '',
        bjcishu: '',
        createtime: ''
      },
      dataRule: {
        // openid: [
        //   { required: true, message: 'openid不能为空', trigger: 'blur' }
        // ],
        // phone: [
        //   { required: true, message: '电话不能为空', trigger: 'blur' }
        // ],
        // type: [
        //   { required: true, message: '用户类型不能为空', trigger: 'blur' }
        // ],
        // rzstatus: [
        //   { required: true, message: '认证状态不能为空', trigger: 'blur' }
        // ],
        // name: [
        //   { required: true, message: '名字不能为空', trigger: 'blur' }
        // ],
        // gsname: [
        //   { required: true, message: '公司名字不能为空', trigger: 'blur' }
        // ],
        // gszhizhao: [
        //   { required: true, message: '公司执照不能为空', trigger: 'blur' }
        // ],
        // vipdqtime: [
        //   { required: true, message: '会员到期时间不能为空', trigger: 'blur' }
        // ],
        // headurl: [
        //   { required: true, message: '头像不能为空', trigger: 'blur' }
        // ],
        // bjcishu: [
        //   { required: true, message: '报价次数不能为空', trigger: 'blur' }
        // ],
        // createtime: [
        //   { required: true, message: '创建时间不能为空', trigger: 'blur' }
        // ]
      }
    }
  },
  methods: {
    init (id) {
      this.dataForm.id = id || 0
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.$http({
            url: this.global.apiUrl + `/jxjg/jguser/info/${this.dataForm.id}`,
            method: 'get',
            params: {
              'id': id
            }
          }).then((data) => {
            data = data.body
            if (data && data.code === 0) {
              this.dataForm.openid = data.jguser.openid
              this.dataForm.phone = data.jguser.phone
              this.dataForm.type = data.jguser.type + ''
              this.dataForm.rzstatus = data.jguser.rzstatus + ''
              this.dataForm.name = data.jguser.name
              this.dataForm.gsname = data.jguser.gsname
              this.dataForm.gszhizhao = data.jguser.gszhizhao
              this.dataForm.vipdqtime = data.jguser.vipdqtime
              this.dataForm.headurl = data.jguser.headurl
              this.dataForm.bjcishu = data.jguser.bjcishu
              this.dataForm.createtime = data.jguser.createtime
            }
          })
        }
      })
    },
    // 表单提交
    dataFormSubmit () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.global.apiUrl + `/jxjg/jguser/${!this.dataForm.id ? 'save' : 'update'}`,
            method: 'post',
            params: {
              'id': this.dataForm.id || undefined,
              'openid': this.dataForm.openid,
              'phone': this.dataForm.phone,
              'type': this.dataForm.type,
              'rzstatus': this.dataForm.rzstatus,
              'name': this.dataForm.name,
              'gsname': this.dataForm.gsname,
              'gszhizhao': this.dataForm.gszhizhao,
              'headurl': this.dataForm.headurl,
              'bjcishu': this.dataForm.bjcishu,
              'vipdqtimestr': this.dataForm.vipdqtime
            }
          }).then((data) => {
            data = data.body
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshDataList')
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/jguser-add-or-update.vue